class ProductItem extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.ColorSwatches__Color').forEach(element => {
      // console.log('color', element);
      element.addEventListener('click', (event) => {
      event.preventDefault();
      this.replaceProductCard(element.dataset.url, element.closest('product-card'));
    });    
  });
  }
  

  async replaceProductCard(url, productCardElement) {
    try {
      // Append query to get the specific view
      url += '?view=grid-item-html';
      let response = await fetch(url);
      let text = await response.text();
      let parser = new DOMParser();
      let htmlDocument = parser.parseFromString(text, 'text/html');
      let newProductCard = htmlDocument.querySelector('product-card');

      if (newProductCard) {
        productCardElement.outerHTML = newProductCard.outerHTML;
      }
    } catch (error) {
      console.error('Error fetching the product card:', error);
    }
  }
}
class QuickViewOpener extends HTMLElement {
  constructor() {
    super();
    this.markup = `<quick-view class="custom-modal" data-url="/products/${this.dataset.productHandle}?view=quick-view">
      <div class="custom-modal__heading">
        <span class="closeButton" onclick="this.closest('quick-view').close()">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10.714 1.286l-9.428 9.428M1.286 1.286l9.428 9.428" stroke-width=".85714"></path>
            </g>
            </svg>
        </span>
      </div>
      <div class="custom-modal__content js-modal-content"></div>
    </quick-view>`;
  }
  connectedCallback() {
    this.addEventListener('click', () => document.querySelector('#quick-view').innerHTML = this.markup)
  }
}
class QuickView extends HTMLElement {
  constructor() {
    super();
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }
  async connectedCallback() {
    console.log(this);
    console.log(this.dataset);
    console.log(this.dataset.url);
    this.open();
    let url = this.dataset.url;
    let response = await fetch(url);
    let text = await response.text();
    let parser = new DOMParser();
    let htmlDocument = parser.parseFromString(text, "text/html");
    let productItem = htmlDocument.documentElement.querySelector('[data-section-type="product"]');
    let popovers = productItem.querySelectorAll('.Popover');
    popovers.forEach((popover) => {
      const id = popover.id;
      const opener = productItem.querySelector(`[aria-controls=${id}]`);
      opener.insertAdjacentElement('afterend', popover);
    })
    
    this.querySelector('.js-modal-content').innerHTML = productItem.outerHTML;
    let sizeGuide = document.querySelector('size-guide');
    if (sizeGuide) this.querySelector('.js-modal-content').insertAdjacentElement('beforebegin', sizeGuide);
    window.themejs.sections.register('product', window.themejs.product);
    this.querySelector('.js-modal-content').querySelectorAll(".ProductForm__Option .CustomSelect").forEach((select) => {
      let instance = NiceSelect.bind(select);
      if (select.nextElementSibling && select.nextElementSibling.querySelectorAll('.nice-select .option')) {
        select.querySelectorAll('option').forEach((option, i) => {
          let obj = option.dataset;
          for (const prop in obj) {
            select.nextElementSibling.querySelectorAll('.nice-select .option')[i].dataset[prop] = obj[prop];
          }
        });
      }
    })
    document.addEventListener('product:added', this.close.bind(this));
  }

  disconnectedCallback() {
    // Clean up event listeners when the component is removed
    this.removeEventListener('open', this.open);
    this.removeEventListener('close', this.close);
  }
  

  open() {
    console.log("open");
    document.body.classList.add('no-scroll');
    document.querySelector(".PageOverlay").classList.add("is-visible", "is-quick-view");
    this.classList.add("is-visible");
  }

  close() {
    console.log('close');
    document.body.classList.remove('no-scroll');
    document.querySelector(".PageOverlay").classList.remove("is-visible", "is-quick-view");
    this.classList.remove("is-visible");
    document.querySelector("#quick-view").innerHTML = "";
  }

  handleOutsideClick(event) {
    const modal = this;
    console.log(modal);
    console.log(event.target);
    if (!modal.contains(event.target)) {
        console.log("close on bg");
        console.log(modal.contains(event.target));
        this.close();
    }
  }

}
customElements.define('product-item', ProductItem);
customElements.define('quick-view', QuickView);
customElements.define('quick-view-opener', QuickViewOpener);





class MonogramComponent extends HTMLElement {
  constructor() {
    super();
    this.maxSymbols = 0;
    this.isInitialized = false; // Add a flag to check initialization

  }

  connectedCallback() {
    if (this.isInitialized) return; // Check if already initialized
    this.isInitialized = true; // Set the flag
    this.inputEl = this.querySelector('input.Monogram__Input');
    this.textEl = this.querySelector('.Monogram__Text');
    this.addToCart = this.inputEl.closest('.product-info').querySelector('button[type="submit"]');    
    this.textLengthEl = this.querySelector('.Monogram__TextLength');

    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('.monogram-select').forEach(select => {
      // Assuming NiceSelect is globally available
      NiceSelect.bind(select);
      this.extraHtmlOption(select);

      select.addEventListener('change', e => this.handleSelectChange(e, select));
    });

    this.inputEl.addEventListener('input', e => this.handleInput(e));
  }

  reset() {
    this.inputEl.value = '';
    this.textEl.innerText = '';
  }

  enableMonogram(enabled) {
    if (enabled == 'no') {
      this.querySelector('.Monogram__Wrapper').style.display = 'none';
      const isStockInStock = this.isProductInStock(); // Check if product in stock for button status
      // console.log(isStockInStock); // For testing

      if (isStockInStock) {
        // Make button active if product in stock
        this.addToCart.removeAttribute('disabled');
      } else {
        // Disable button if out of stock
        this.addToCart.setAttribute('disabled', true);
      }
    }
    if (enabled == 'yes') {
      this.querySelector('.Monogram__Wrapper').style.display = 'block';
      this.toggleAddToCart();
    }
  }

  toggleAddToCart() {
    const checkbox = this.querySelector('input#monogram-accept');
    const isStockInStock = this.isProductInStock(); // Check if product in stock for button status
    if (checkbox.checked && this.inputEl.value) {
      if (isStockInStock) {
        // Make button active if product in stock
        this.addToCart.removeAttribute('disabled');
      } else {
        // Disable button if out of stock
        this.addToCart.setAttribute('disabled', true);
      }
    } else {
      this.addToCart.setAttribute('disabled', true);
    }
  }

  isProductInStock() {
    return this.addToCart.getAttribute('data-stock') === 'in-stock';
  }

  extraHtmlOption(select) {
    if (select.nextElementSibling && select.nextElementSibling.querySelectorAll('.nice-select .option')) {
      select.querySelectorAll('option').forEach((option, i) => {
        if (option.dataset.extraHtml) {
          const extraHtml = document.createElement('div');
          extraHtml.classList.add('extra-html');
          extraHtml.innerHTML = option.dataset.extraHtml;
          select.nextElementSibling.querySelectorAll('.nice-select .option')[i].appendChild(extraHtml);
        }
      });
    }
  }

  copyHtml(select) {
    setTimeout(() => {
      if (select.nextElementSibling && select.nextElementSibling.querySelector('.nice-select .option.selected')) {
        const htmlToCopy = select.nextElementSibling.querySelector('.nice-select .option.selected').innerHTML;
        select.nextElementSibling.querySelector('.nice-select .current').innerHTML = htmlToCopy;
      }
    }, 0);
  }

  handleSelectChange(e, select) {
    this.copyHtml(select);
    if (select.id == 'monogram-style') {
      this.reset();
      const selectedText = select.options[select.selectedIndex].text;
      this.maxSymbols = select.querySelector('option:checked').dataset.maxSymbols;
      this.inputEl.placeholder = selectedText;
      this.inputEl.dataset.monogramStyle = this.textEl.dataset.monogramStyle = e.target.value;
      
      setTimeout(() => {
        this.inputEl.maxLength = this.maxSymbols;
        this.textLengthEl.innerText = `${this.inputEl.value.length} / ${this.maxSymbols}`;
      }, 50);
    }
    if (select.id == 'monogram-color') {
      this.inputEl.dataset.monogramColor = this.textEl.dataset.monogramColor = e.target.value;
    }
    if (this.inputEl.dataset.monogramColor && this.inputEl.dataset.monogramStyle) {
      this.inputEl.removeAttribute('disabled');
    }
    this.toggleAddToCart();
  }

  handleInput(e) {
    this.toggleAddToCart();
    if (this.maxSymbols == 0) {
        setTimeout(() => this.reset(), 50);
        return;
    }

    const inputValue = this.inputEl.value;
    const selectedStyle = this.inputEl.dataset.monogramStyle;

    // Update preview based on selected font style (Custom styles for some fonts)
    if (selectedStyle === 'modern-1' || selectedStyle === 'calligraphy-1') {
      if (inputValue === '') {
        // If input is empty, reset the preview and text length
        this.textEl.innerText = '';
        this.textLengthEl.innerText = `0 / ${this.maxSymbols}`;
      } else {
          // Add full stop after each letter for 'modern-1' font
          const modifiedValue = inputValue.split('').join('.') + '.'; // Add a full stop after the last letter as well
          this.textEl.innerText = modifiedValue;
          
          // Count characters excluding full stops
          const characterCount = inputValue.replace(/\./g, '').length;
          this.textLengthEl.innerText = `${characterCount} / ${this.maxSymbols}`;
      }
    } else if (selectedStyle === 'scroll' || selectedStyle === 'classic-2' || selectedStyle === 'calligraphy-2') {
        // Apply scaling to the second letter
        const scaledValue = this.scaleSecondLetter(inputValue, 150);
        this.textEl.innerHTML = scaledValue;
        
        // Count characters including the scaled second letter
        const characterCount = scaledValue.replace(/<[^>]*>/g, '').length;
        this.textLengthEl.innerText = `${characterCount} / ${this.maxSymbols}`;
    } else {
        this.textEl.innerText = inputValue;
        this.textLengthEl.innerText = `${inputValue.length} / ${this.maxSymbols}`;
    }
}

  scaleSecondLetter(text, scalePercentage) {
    if (text.length <= 1) {
        return text; // No need to scale if the text has one or zero characters
    }

    // Split the text into an array of characters
    var characters = text.split('');
    // Apply the scaling to the second letter
    characters[1] = `<span style="font-size: ${scalePercentage}%;">${characters[1]}</span>`;
    // Join the characters back into a string
    return characters.join('');
  }


}



class SizeGuideComponent extends HTMLElement {
  constructor() {
      super();
      // Bind methods to the instance
      this.openSizeGuide = this.openSizeGuide.bind(this);
      this.closeSizeGuide = this.closeSizeGuide.bind(this);
  }

  connectedCallback() {
      // Add event listeners when the component is added to the document
      this.addEventListener('openSizeGuide', this.openSizeGuide);
      this.addEventListener('closeSizeGuide', this.closeSizeGuide);

      this.initializeSizeGuide();
  }

  disconnectedCallback() {
      // Clean up event listeners when the component is removed
      this.removeEventListener('openSizeGuide', this.openSizeGuide);
      this.removeEventListener('closeSizeGuide', this.closeSizeGuide);
  }

  openSizeGuide() {
    if (document.body.classList.contains('template-product')) {
      document.querySelector(".PageOverlay").classList.add("is-visible");
    }
      this.classList.add("is-visible");
      if (this.closest('quick-view') != undefined) this.closest('quick-view').classList.add('has-child');
    }
    
    closeSizeGuide() {
      if (document.body.classList.contains('template-product')) {
        document.querySelector(".PageOverlay").classList.remove("is-visible");
      }
      this.classList.remove("is-visible");
      if (this.closest('quick-view') != undefined) this.closest('quick-view').classList.remove('has-child');
  }



  handleRadioButtonChange(radioButton) {
    const selectedId = radioButton.id;
    const classToShow = selectedId.endsWith('-inches-btn') ? 'sizeguide-inch' : 'sizeguide-cm';

    const tables = document.querySelectorAll(`.clothing-sizing__tables table`);
    tables.forEach(table => table.style.display = 'none');

    const tableToShow = document.querySelector(`.clothing-sizing__tables .${classToShow}`);
    if (tableToShow) tableToShow.style.display = 'table';
}

initializeSizeGuide() {
  const radioButtonsMeasure = document.querySelectorAll('input[name$="-measure-type"]');

  radioButtonsMeasure.forEach(radioButton => {
      radioButton.addEventListener('change', () => this.handleRadioButtonChange(radioButton));
  });
}
}

// Define the closeSizeGuide function here
const closeSizeGuide = () => {
  const sizeGuideModal = document.querySelector('size-guide');
  sizeGuideModal.closeSizeGuide();
}

customElements.define('size-guide', SizeGuideComponent);